import { CloseIcon } from 'src/modules/year-end-forms/styles';
import styled from 'styled-components';

export const UserAdditionBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #f3f4f8;
  margin-left: -19px;
  border-radius: 20px;
  width: 105%;
  height: 100%;
`;

export const CommonInputDiv = styled.div`
  width: 300px;
  select {
    width: 100%;
  }
`;

export const InputContainer = styled.div`
  padding: 30px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 30px;
  opacity: 1;
  width: 100%;

  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const UserAdditionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 7px;
  font: Biotif, Medium;
  color: #1c1b3a;
  opacity: 1;
  hieght: 12px;
  margin-top: 14px;
  margin-left: 8px;
  font-size: 26px;
  font-weight: 600;
  ${CloseIcon} {
    cursor: pointer;
  }
`;

export const UserAdditionFormRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
`;

export const UserAdditionFormRowLast = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const UserAdditionForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  hieght: 400px;
`;
